import type { SensitivityTier } from "../../pages/PortfolioPerformance/lib/api/shared";
import type { MacroTier } from "../../pages/PortfolioPerformance/lib/api/macro-exposure";

// Red / Amber / Green, the same three tokens every other risk signal in Portfolio Performance uses
// (--decline red, --amber amber, --approve green). Score bands: 0-49 green (low risk), 50-74 amber,
// 75+ red (the cut-offs themselves are the configurable grid). Low was a one-off yellow, which read as a
// warning rather than as "fine".
export const TIER_COLOR: Record<SensitivityTier, string> = {
  High: "var(--decline)",
  Medium: "var(--amber)",
  Low: "var(--approve)",
};

export const TIER_ORDER: SensitivityTier[] = ["High", "Medium", "Low"];

// Used when the tier grid has not loaded yet: the bands the grid ships with.
const DEFAULT_TIERS: MacroTier[] = [
  { tier: "Low", minScore: 0 },
  { tier: "Medium", minScore: 50 },
  { tier: "High", minScore: 80 },
];

/** The band a 0-100 score falls in: the highest tier whose start it has reached. */
export function tierForScore(score: number, tiers: MacroTier[] | undefined): SensitivityTier {
  const sorted = [...(tiers?.length ? tiers : DEFAULT_TIERS)].sort((a, b) => b.minScore - a.minScore);
  return (sorted.find((t) => score >= t.minScore) ?? sorted[sorted.length - 1]!).tier;
}

/** The sensitivity bands, lowest first: where each starts and ends on the y axis (the top band ends at `top`, the
 *  axis maximum), and its middle, where its axis label sits. Falls back to the shipped bands until the tier grid has
 *  loaded. */
export function tierBands(tiers: MacroTier[] | undefined, top = 100) {
  return [...(tiers?.length ? tiers : DEFAULT_TIERS)]
    .sort((a, b) => a.minScore - b.minScore)
    .map((t, i, all) => {
      const to = all[i + 1]?.minScore ?? top;
      return { tier: t.tier, from: t.minScore, to, mid: (t.minScore + to) / 2 };
    });
}
